import { CursorClickIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MouseClick = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CursorClickIcon {...rest} size={Sizes[size]} color={fill} />;
};

MouseClick.displayName = 'MouseClick';
